import { IfpLoansDropdownWizardData as FormData } from '@sec-loans-ui/common/steps/assistance-step/components/ipf-loans-dropdown/IfpLoansDropdown'
import { FieldName } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import { create, enforce, only, Suite, test } from 'vest'

export const createFormValidator = (
  formatMessage: IntlShape['formatMessage'],
): Suite<string, string, (data: Partial<FormData>, changedFields?: FieldName<FormData>[]) => void> =>
  create((data, changedFields) => {
    only(changedFields)

    test('selectedCreditId', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.selectedCreditId).isNotUndefined()
      enforce(data.selectedCreditId).isNotEmpty()
    })
  })
